module.exports = __webpack_public_path__ + "img/cryptoTeller.147e9b2e.jpeg";